import { PinStatus, IDeviceGridPattern } from './grid.model';

export const CombBus3LNPattern: IDeviceGridPattern = {
  pattern: [PinStatus.neutral, PinStatus.phase],
  repeatingPosition: 0
};
export const CombBusFIPattern: IDeviceGridPattern = {
  pattern:
    [PinStatus.half_neutral_left, PinStatus.half_neutral_right, PinStatus.half_phase_left, PinStatus.half_phase_right,
      PinStatus.half_phase_left, PinStatus.half_phase_right, PinStatus.half_phase_left, PinStatus.half_phase_right,
      PinStatus.neutral, PinStatus.phase],
  repeatingPosition: 8
};

export const NOT_BILLABLE = 'NO_BOM';
export const EASY_NET_DEVICE_ID = 1327;
export const PATCHPANEL_16_PORT_DEVICE_ID = 1337;
export const PATCHPANEL_16_PORT_SHIELDED_DEVICE_ID = 1391;
export const PATCHPANEL_8_PORT_DEVICE_ID = 1338;
export const GATEWAY_DEVICE_ID = 1353;
export const METERING_DEVICE_OPTION_DISABLE_CERTIFICATION = ['No', 'Nein', 'Non'];
export const METERING_DEVICE_OPTION_DISABLE_PROTOCOL = ['None', '-'];
export const RATED_CURRENT_ALLOWED_ONLY_ON_280_ENCLOSURE = ['500A', '570A', '630A'];
export const BREAKING_CAPACITY_IEC_60947_2_ALLOWED_ONLY_ON_280_ENCLOSURE = ['50kA'];
export const FRAME_RATINGS_ALLOWED_ONLY_ON_280_ENCLOSURE = ['NSX630'];

export const MULTIMEDIA_CATALOGUE_DATASHEET_LINK = 'https://online-katalog.feller.ch/kat_details.php?fnr='

export const CSS_CLASS_OVERLAY_DEVICE_COLOUR_BASED_ON_LEVEL = 'overlay-device-level-';
export const CSS_CLASS_DEVICE_LABEL_BG_COLOUR_BASED_ON_LEVEL = 'label-bg-level-';
export const CSS_CLASS_OVERLAY_COMB_BUS_BAR_DEVICE_COLOUR = 'overlay-comb-bus-bar-sld';

export const REFERENCES_WITH_DISABLED_BOM_PDF = ['KLEMME_3LN', 'KLEMME_1LN', 'KLEMME_3LN_PE', 'KLEMME_1LN_PE',
  'CXXXXXXX', 'NCXXXXXX', 'NXXXXXXX', 'NX4063XXXXXX', 'NX4P4063XXXX', 'NX4P1025XXXX'];

export enum DeviceOptions {
  NO_BRIDGE = 'NO_BRIDGE',
  WITH_COVER = 'WITH_COVER',
  NO_COVER = 'NO_COVER'
}
